import { render, staticRenderFns } from "./Slider2.vue?vue&type=template&id=535aca31&scoped=true&"
import script from "./Slider2.vue?vue&type=script&lang=js&"
export * from "./Slider2.vue?vue&type=script&lang=js&"
import style0 from "./Slider2.vue?vue&type=style&index=0&id=535aca31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535aca31",
  null
  
)

export default component.exports